"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var ramda_1 = require("ramda");
var PlaybackPosition_1 = require("../../types/models/PlaybackPosition");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
function getPlaybackPositionMap(obj) {
    return ramda_1.fromPairs(PlaybackPosition_1.PlaybackPosition.createInstances(Object.values(obj)).map(function (item) { return [item.contentId, item]; }));
}
exports.getPlaybackPositionMap = getPlaybackPositionMap;
var reducers = {
    playbackMetaByMediaAssetId: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_PLAYBACK_META,
        onSuccess: function (state, action) {
            var _a;
            if ((_a = action.meta) === null || _a === void 0 ? void 0 : _a.isLive) {
                state.data[action.meta.mediaAssetId] = __assign({ id: action.meta.mediaAssetId }, action.payload.startLinearPlayback);
            }
            else {
                state.data[action.meta.mediaAssetId] = __assign({ mediaAssetId: action.meta.mediaAssetId }, action.payload.startVodPlayback);
            }
        },
    })), (_a = {}, _a[constants_1.REMOVE_PLAYBACK_META] = function (state, action) {
        var mediaAssetId = action.payload;
        delete state.data[mediaAssetId];
        delete state.error;
    }, _a[constants_1.SET_PLAYBACK_META] = function (state, action) {
        state.data[action.payload.mediaAssetId] = action.payload.playback;
    }, _a)), api_1.createApiInitialState({})),
    playbackConcurrencyById: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.STOP_PLAYBACK,
        onSuccess: function (draftState, action) {
            var mediaAssetId = action.meta.mediaAssetId;
            var heartbeatTimeout = draftState.data[mediaAssetId];
            if (heartbeatTimeout) {
                clearTimeout(heartbeatTimeout);
                delete draftState.data[mediaAssetId];
            }
        },
    })), (_b = {}, _b[constants_1.SET_PLAYBACK_HEARTBEAT] = function (state, action) {
        var _a = action.payload, mediaAssetId = _a.mediaAssetId, heartBeatInterval = _a.heartBeatInterval;
        state.data[mediaAssetId] = heartBeatInterval;
    }, _b)), api_1.createApiInitialState({})),
    offlinePlaybackMetaByMediaAssetId: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_OFFLINE_PLAYBACK_META,
        onSuccess: function (state, action) {
            state.data[action.meta.mediaAssetId] = __assign({ mediaAssetId: action.meta.mediaAssetId }, action.payload.getOfflineVodPlayback);
        },
    })), api_1.createApiInitialState({})),
    textTracksByMediaAssetId: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_TEXT_TRACKS] = function (state, action) {
            var _a = action.payload, mediaAssetId = _a.mediaAssetId, textTracks = _a.textTracks;
            state[mediaAssetId] = __spreadArrays(textTracks);
        },
        _c[constants_1.CLEAR_TEXT_TRACKS] = function () { return ({}); },
        _c), {}),
    audioTracks: api_1.createCustomModuleReducer((_d = {},
        _d[constants_1.SET_AUDIO_TRACKS] = function (state, action) { return action.payload; },
        _d[constants_1.CLEAR_AUDIO_TRACKS] = function () { return []; },
        _d), {}),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map